/**
 * Credits Service
 * T027: Implement CreditsService for credit management
 */

import type { GatewayClient } from './client'
import type {
  CreditPacksResponse,
  CreateCheckoutRequest,
  CheckoutResponse,
  CreditHistoryResponse,
} from './types'

// ============================================================================
// Types
// ============================================================================

export interface CreditHistoryOptions {
  limit?: number
  offset?: number
  [key: string]: string | number | boolean | undefined
}

export interface CreditsService {
  /**
   * Get available credit packs
   */
  getPacks(): Promise<CreditPacksResponse>

  /**
   * Create Stripe checkout session for purchasing credits
   */
  createCheckout(request: CreateCheckoutRequest): Promise<CheckoutResponse>

  /**
   * Get credit transaction history
   */
  getHistory(options?: CreditHistoryOptions): Promise<CreditHistoryResponse>
}

// ============================================================================
// Implementation
// ============================================================================

/**
 * Create a CreditsService instance
 */
export function createCreditsService(client: GatewayClient): CreditsService {
  return {
    async getPacks(): Promise<CreditPacksResponse> {
      return client.get<CreditPacksResponse>('/v1/credits/packs')
    },

    async createCheckout(
      request: CreateCheckoutRequest
    ): Promise<CheckoutResponse> {
      return client.post<CheckoutResponse>('/v1/credits/checkout', request)
    },

    async getHistory(
      options?: CreditHistoryOptions
    ): Promise<CreditHistoryResponse> {
      return client.get<CreditHistoryResponse>('/v1/account/credits/history', {
        params: options,
      })
    },
  }
}
